import { render, staticRenderFns } from "./DsgvoDocumentationDetail.vue?vue&type=template&id=f3dedb54&"
import script from "./DsgvoDocumentationDetail.vue?vue&type=script&lang=js&"
export * from "./DsgvoDocumentationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports